import { ark } from "@ark-ui/react/factory";
import { styled } from "@repo/styled-system/jsx";
import { kbd } from "@repo/styled-system/recipes";
import type { ComponentProps } from "@repo/styled-system/types";

export type KbdProps = ComponentProps<typeof Kbd>;
export const Kbd = styled(ark.kbd, kbd);
